<template>
  <div>
    <portal to="dash-modal">
      <ChangeQuotationStatus 
        v-if="quotationToChange" 
        :quotation="quotationToChange" 
        @close="setQuotationToChange(null)" 
        @status-change="onQuotationStatusChange" 
      />
    </portal>

    <QuotationMasterModal
      v-if="!loading && masterModal"
      ref="master-modal"
      :quotation-id="parseInt(quotationId)"
      :stage="masterModal"
      @close="closeQuotationsModal"
    />
    <TitleBar>
      <template v-slot:title><translate>Quotations</translate></template>
      <template v-slot:buttons>
        <GekkoButton 
          :to="{ name: 'QuotationAdd' }"
          :text="$gettext('New')"
          icon="fa-solid fa-plus"
        />
      </template>
    </TitleBar>
    <div class="content">
      <div v-if="!$store.getters['getIsPremium']" class="gk-tip gk-tip--warning gk-tip--caution my-4" :style="tipCssVars">
        <span>{{ $gettext('As a non-Premium user, you can only create up to three quotations. Please consider ') }}</span>
        <a href="/en/subscriptions/manage/">{{ $gettext('upgrading!') }}</a>
      </div>
      <InvoicesTable :quotationsList="true" ref="quotations-table" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import QuotationMasterModal from "@/components/quotations/ui/QuotationMasterModal"
import ChangeQuotationStatus from "@/components/invoices/ui/ChangeQuotationStatus";

import TitleBar from '@/components/TitleBar'
import GekkoButton from '@/components/GekkoButton'
import InvoicesTable from '@/components/invoices/InvoicesTable'

export default {
  name: 'Quotations',
  components: {
    TitleBar,
    GekkoButton,
    InvoicesTable,
    QuotationMasterModal,
    ChangeQuotationStatus
  },
  data () {
    return {
      masterModal: null,
      showUploadModal: false,
      modalType: null,
      quotationId: null,
      loading: true,
    }
  },
  computed: {
    ...mapGetters({ 
      quotationToChange: 'invoices/getQuotationToChange',
    }),
    tipCssVars() {
      return `--cautiontext: '${ this.$gettext('Gekko premium tip') }'`
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        this.masterModal = to.meta.masterModal
        this.showUploadModal = to.meta.showUploadModal
        this.modalType = to.meta.modalType
        this.quotationId = this.$route.params['quotationId']

        if (this.masterModal) {
          document.body.classList.add('master-modal-on')
        } else {
          document.body.classList.remove('master-modal-on')
        }
      }
    },
  },
  created () {
    this.loadInvoicesGlobalData().then(() => {
      this.loading = false
    })
  },
  methods: {
    ...mapActions ({ 
      loadInvoicesGlobalData: "invoices/loadInvoicesGlobalData",
      setQuotationToChange: "invoices/setQuotationToChange",
    }),
    reloadFilters () {
      if (this.$refs['quotations-table']) {
        this.$refs['quotations-table'].reloadFilterStore()
      }
    },
    refreshList () {
      this.$store.commit('invoices/REFRESH_INVOICE_LIST')
    },
    closeQuotationsModal () {
      this.masterModal = null
      this.modalType = null
      this.reloadFilters()
      this.$router.push({ name: 'Quotations' }).catch(() => {})
    },
    onQuotationStatusChange () {
      this.$refs['master-modal'].setupData()
      this.refreshList()
    }
  }
}
</script>

<style scoped lang="scss">
  .gk-tip--caution:after {
    content: var(--cautiontext);
  }
</style>